// jQuery start
jQuery(function () {
  // Smooth scroll
  /*
    jQuery('a[href^="#"]').click(function () {
      var speed = 800;
      var href = jQuery(this).attr("href");
      var target = jQuery(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      jQuery("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    }); //Smooth scroll END
    */

  // loading
  // jQuery(document).ready(function () {
  //   jQuery(".loading").addClass("active");
  // });

  jQuery(window).on("load", function () {
    jQuery(".loading").addClass("active");
  });

  // scroll class add
  jQuery(window).on("load scroll resize", function () {
    var st = jQuery(window).scrollTop();
    var wh = jQuery(window).height();
    var ww = jQuery(window).width();

    // fast(<1) slow(>1)
    jQuery(".fade, .fadeMask, .fadeUp, .fadeIn").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.9;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });

    jQuery(".fadeUp-fast").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.85;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });

    jQuery(".fadeUp-slow, .fadeUp-slow2").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.85;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });

    jQuery(".fadeUp-slow, .fadeUp-slow2").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.85;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });

    jQuery(".fadeUp-list").each(function (i) {
      var tg = jQuery(this).offset().top - wh;
      if (st > tg) {
        jQuery(this)
          .delay(300 * i)
          .queue(function (next) {
            jQuery(this).addClass("active");
            next();
          });
      }
    });
  }); // scroll class add END

  // Click event humberger menu
  jQuery(".navBar").click(function () {
    jQuery(".l-header").toggleClass("active");
    jQuery(".navBar__line").toggleClass("active");
    jQuery(".header__body").toggleClass("active");
    jQuery(".header__snav").toggleClass("active");
  });
});
// jQuery End

// // scroll = class add
// window.onscroll = function () {
//   // go to top btn
//   var page_top = document.getElementById('pageTop');
//   if (window.pageYOffset > 800) {
//     page_top.classList.add("active");
//   } else {
//     page_top.classList.remove("active");
//   }
// }

// ====================================
// scroll smooth
// ====================================

jQuery(function ($) {
  jQuery('a[href*="#"]').click(function () {
    console.log("TEST");
    var speed = 800;
    var href = jQuery(this).attr("href");
    var url = location.protocol + "//" + location.hostname + location.pathname;
    href = href.replace(url, "");
    var target = jQuery(href == "#" || href == "" ? "html" : href);
    if (target.size() < 1) return true;
    var position = target.offset().top;
    jQuery("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "swing"
    );
    return false;
  });
});

// ====================================
// footerを下に固定
// ====================================
new (function () {
  var footerId = "footer";
  //メイン
  function footerFixed() {
    //ドキュメントの高さ
    var dh = document.getElementsByTagName("body")[0].clientHeight;
    //フッターのtopからの位置
    document.getElementById(footerId).style.top = "0px";
    var ft = document.getElementById(footerId).offsetTop;
    //フッターの高さ
    var fh = document.getElementById(footerId).offsetHeight;
    //ウィンドウの高さ
    if (window.innerHeight) {
      var wh = window.innerHeight;
    } else if (
      document.documentElement &&
      document.documentElement.clientHeight != 0
    ) {
      var wh = document.documentElement.clientHeight;
    }
    if (ft + fh < wh) {
      document.getElementById(footerId).style.position = "relative";
      document.getElementById(footerId).style.top = wh - fh - ft - 1 + "px";
    }
  }

  //文字サイズ
  function checkFontSize(func) {
    //判定要素の追加
    var e = document.createElement("div");
    var s = document.createTextNode("S");
    e.appendChild(s);
    e.style.visibility = "hidden";
    e.style.position = "absolute";
    e.style.top = "0";
    document.body.appendChild(e);
    var defHeight = e.offsetHeight;

    //判定関数
    function checkBoxSize() {
      if (defHeight != e.offsetHeight) {
        func();
        defHeight = e.offsetHeight;
      }
    }
    setInterval(checkBoxSize, 1000);
  }

  //イベントリスナー
  function addEvent(elm, listener, fn) {
    try {
      elm.addEventListener(listener, fn, false);
    } catch (e) {
      elm.attachEvent("on" + listener, fn);
    }
  }

  addEvent(window, "load", footerFixed);
  addEvent(window, "load", function () {
    checkFontSize(footerFixed);
  });
  addEvent(window, "resize", footerFixed);
})();

// ====================================
// 電話番号画像スマホ時にリンク
// ====================================
jQuery(function () {
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") < 0 && ua.indexOf("Android") < 0) {
    jQuery(".telhref span").each(function () {
      jQuery(this).unwrap();
    });
  }
});

// ====================================
// オリジナルjs
// ====================================

// ====================================
// slider
// ====================================

jQuery(function () {
  var slider = ".kv__list"; // スライダー
  var textItem = ".kv__textSlider__list .kv__textSlider__item"; // text
  var dotItem = ".kv__sliderdot__list .kv__sliderdot__item"; // ドット

  jQuery(dotItem).each(function () {
    var index = $(dotItem).index(this);
    $(this).attr("data-index", index);
  });

  jQuery(textItem).each(function () {
    var index = $(textItem).index(this);
    $(this).attr("data-index", index);
  });

  // スライダー初期化後、カレントのドットにクラス「is-active」を付ける
  jQuery(slider).on("init", function (slick) {
    var index = $(".kv__item.slick-slide.slick-current").attr(
      "data-slick-index"
    );
    $(dotItem + '[data-index="' + index + '"]').addClass("is-active");
    $(textItem + '[data-index="' + index + '"]').addClass("is-active");
  });

  //スライダー
  jQuery(slider).slick({
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 1500,
    fade: true,
    cssEase: "linear",
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  //ドットをクリックしたときにスライダー切り替え
  jQuery(dotItem).on("click", function () {
    var index = $(this).attr("data-index");
    $(slider).slick("slickGoTo", index, false);
  });

  //ドットのカレントを切り替え
  jQuery(slider).on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(dotItem).each(function () {
        $(dotItem).removeClass("is-active");
        $(textItem).removeClass("is-active");
      });
      $(dotItem + '[data-index="' + nextSlide + '"]').addClass("is-active");
      $(textItem + '[data-index="' + nextSlide + '"]').addClass("is-active");
    }
  );
});

// ====================================
// header scroll
// ====================================
jQuery(function () {
  jQuery(window).on("load scroll resize", function () {
    var st = jQuery(window).scrollTop();

    if (st > 1) {
      jQuery(".l-header").addClass("is-scroll");
    } else {
      jQuery(".l-header").removeClass("is-scroll");
    }
  }); // scroll class add END
});

// ====================================
// tab (top page works)
// ====================================
jQuery(function () {
  var tabs = $(".tab__btn");

  $(".tab__btn").on("click", function () {
    $(".tab__btn.is-active").removeClass("is-active");
    $(this).addClass("is-active");
    var index = tabs.index(this);
    $(".tab__main").removeClass("is-show").eq(index).addClass("is-show");
  });
});

// ====================================
// faq
// ====================================

jQuery(function () {
  $(".faq-click").on("click", function () {
    $(this).children(".faq-click__a").slideToggle(200);
  });
});
